import { createAction } from "@reduxjs/toolkit"

export const toggleUtilityModalVisibility = createAction("TOGGLE_UTILITY_MODAL_VISIBILITY")
export const updateAccessToken = createAction("UPDATE_ACCESS_TOKEN")